import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_NO.json';
import audios from './LOVE_AUDIOS_NO.json';

export const LOVE_DATA_NO: ServiceData = {
  articles,
  audios,
};
